module.exports = __webpack_public_path__ + "img/power_treads_str.5cf95fca.png";